<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtolistkasbon">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Tambah Kasbon</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page flex-100">
            <div class="flex-1 p-x-20 p-y-20 w-limit">
                <div class="mod">
                    <label class="form-label require">Pilih Karyawan</label>
                    <Select2 class="test-select fl-is-required inputs" id="pilih-karyawan"
                        :settings="{ placeholder: 'Pilih Karyawan' }" v-model="selectedkaryawan_kasbon"
                             :options="optionkaryawan_kasbon" @change="myChangeEventkaryawan($event)" v-on:change="cekValidate;" />
	                <ErrorMessage class="error" label="Pilih Karyawan" :validation="$v.selectedkaryawan_kasbon"></ErrorMessage>
                </div>
                <div class="m-t-16">
                    <label for="nominal-kasbon" class="form-label require">Nominal</label>
                    <div class="input-group mod">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Rp</span>
                        </div>
                        <input type="telp" class="form-control" id="nominal-kasbon" placeholder="123.456"
                               v-model="nominal_kasbon" @keyup="inputnominalCreatekasbon">
                    </div>
	                <ErrorMessage class="error" label="Nominal" :validation="$v.nominal_kasbon"></ErrorMessage>
                </div>
                <div class="form-group mod m-t-16">
                    <label for="tgl_kasbon" class="form-label require">Tanggal Kasbon</label>
                    <input type="datetime-local" class="form-control" id="tgl_kasbon" @change="cekValidate"
                        placeholder="Ketuk untuk menyetel..." v-model="date_kasbon">
	                <span id="cekTanggalValid" style="color: red; display: none">
		                <small>Waktu pelunasan tidak boleh melebihi waktu saat ini</small>
	                </span>
	                <ErrorMessage class="error" label="Pilih Karyawan" :validation="$v.date_kasbon"></ErrorMessage>
                </div>
                <div class="mod m-t-16">
                    <label class="form-label require">Pilih akun untuk kasbon</label>
                    <select class="form-control" v-model="selectedkasbon" @change="cekValidate">
                        <option value="" selected>
                            Pilih Akun Keuangan
                        </option>
                        <optgroup  label="Aset">
                        </optgroup>
                        <optgroup  label="Kas">
                            <option v-for="optionkasbonx in selectedakunkasbon" v-bind:value="{value:optionkasbonx.id, text: optionkasbonx.text}" v-if="optionkasbonx.idkategori==='1.01.000'" >{{optionkasbonx.text}}</option>
                        </optgroup>
                        <optgroup label="Bank">
                            <option v-for="optionkasbonx in selectedakunkasbon" v-bind:value="{value:optionkasbonx.id, text: optionkasbonx.text}" v-if="optionkasbonx.idkategori==='1.02.000'">{{optionkasbonx.text}}</option>
                        </optgroup>
                    </select>
	                <ErrorMessage class="error" label="Akun" :validation="$v.selectedkasbon"></ErrorMessage>
                </div>
                <div class="form-group mod  m-t-16">
                  <div class="wrapper">
                    <label for="radio1" class="form-label">Catat sebagai kasbon</label>
                    <div class="radio-group">
                      <div class="radio-wrapper">
                        <div class="radio-item" >
                          <input type="radio" id="radio1" name="radioboxx" value="perusahaan" v-model="type_beban_kasbon">
                          <label for="radio1">Perusahaan</label>
                        </div>
                        <div class="radio-item" >
                          <input type="radio" id="radio2" name="radioboxx" value="outlet" v-model="type_beban_kasbon">
                          <label for="radio2">Outlet</label>
                        </div>
                        <div class="radio-item" >
                          <input type="radio" id="radio3" name="radioboxx" value="workshop" v-model="type_beban_kasbon" >
                          <label for="radio3">Workshop</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mod m-t-16" v-if="type_beban_kasbon==='outlet'">
                  <label class="form-label require" for="select2">Pilih Outlet</label>
                  <Select2 class="test-select fl-is-required inputs" id="select2" v-model="idoutlet"
                           :settings="{ placeholder: 'Pilih Outlet' }" :options="OptionOutlet"
                  />
                  <ErrorMessage class="error" label="Pilih outlet" :validation="$v.idoutlet"></ErrorMessage>
                </div>
                <div class="form-group mod m-t-16" v-if="type_beban_kasbon==='workshop'">
                  <label class="form-label require" for="select2sec">Pilih Workshop</label>
                  <Select2 class="test-select fl-is-required inputs" id="select2sec"
                           v-model="idworkshop" :settings="{ placeholder: 'Pilih Workshop' }"
                           :options="OptionWorkshop"/>
                  <ErrorMessage class="error" label="Pilih workshop" :validation="$v.idworkshop"></ErrorMessage>
                </div>
                <div class="form-group mod m-t-16">
                    <label for="ket_kasbon" class="form-label require">Keterangan</label>
                    <input type="text" class="form-control" id="ket_kasbon"
                        placeholder="Tulis keterangan..." v-model="keterangan_kasbon" @keyup="cekValidate">
	                <ErrorMessage class="error" label="Keterangan" :validation="$v.keterangan_kasbon"></ErrorMessage>
                </div>
            </div>
            <div class="button-wrapper p-x-20 p-y-20 w-limit w-100">
                <button class="btn smart-primary" id="BtnCreateKasbon" @click="createkasbon">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                          v-if="isClicked === true"></span><span id="textBtnCreateKasbon">Simpan</span></button>
            </div>
        </div>

    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minLength, required, requiredIf} from "vuelidate/lib/validators";
    import { mapState} from "vuex";
    
    export default {
        name:'tambahkasbon',
        components: {
            Select2,
	        ErrorMessage
        },
        data(){
            return{
                isClicked:false,
                OptionOutlet: [],
                OptionWorkshop: [],
                listkasbon:[],
                listkasbonsearch:[],
                leght_data_kasbonx:'',
                optionkaryawan_kasbon:[],
                selectedkaryawan_kasbon:'',
                selectedakunkasbon:[],
                selectedkasbon:'',
                nominal_kasbon:'',
                keterangan_kasbon:'',
                date_kasbon:'',
                type_beban_kasbon:"perusahaan", //outlet,workshop
                idoutlet:"",
                idworkshop:"",
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
	    validations: {
        idoutlet: {
          required: requiredIf(function() {
            return (this.type_beban_kasbon === 'outlet');
          })
        },
        idworkshop: {
          required: requiredIf(function() {
            return (this.type_beban_kasbon === 'workshop');
          })
        },
		    selectedkaryawan_kasbon: {
		    	required,
		    },
		    nominal_kasbon: {
		    	required,
			    minLength: minLength(1),
		    },
		    date_kasbon: {
		    	required,
		    },
		    selectedkasbon: {
		    	required,
		    },
		    keterangan_kasbon: {
		    	required,
			    minLength: minLength(2),
		    }
	    },
        mounted() {
            this.getKaryawankasbon();
            this.getdatakaunkasbon();
            this.getWorkshop();
            this.getOutlet();
            this.today();
            this.setdate();
            this.cekValidate()

            this.backButtonPressed(this.backtolistkasbon)
        },
        computed: {
            ...mapState("metaModule", {
                listKaryawanMeta: "karyawanAll",
            }),
        },
        methods:{
            backtolistkasbon(){
                this.$emit('backtolistkasbon')
            },

            setdate(){
                $('#tgl_kasbon').attr('max',this.date_kasbon)
            },

            today(){
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();
                var HH = today.getHours();
                var minutes = today.getMinutes()
                if(minutes < 10) {
                    minutes = "0" + minutes
                }

                if(HH < 10) {
                    HH = "0" + HH
                }

                today = yyyy + '-' + mm + '-' + dd + 'T' + HH +':'+ minutes;
                this.date_kasbon = today;
            },

            // <-- Fungsi Formatrupiah nominal create kasbon -->

            inputnominalCreatekasbon(){
                var handlecicil = this.nominal_kasbon;
                var hasilcicil = handlecicil.replace(/[^0-9]+/g,'');
                this.nominal_kasbon=hasilcicil;
                this.cekValidate()
                this.formatrupiahnominalCreatekasbon();
            },

            formatrupiahnominalCreatekasbon(){
                var rupiahcicil = this.nominal_kasbon;
                var formattedrupiahcicil = this.newrupiahnominalCreatekasbon(rupiahcicil);
                this.nominal_kasbon=formattedrupiahcicil;
            },

            newrupiahnominalCreatekasbon(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = parseInt(split[0]).toString().length % 3,
                    rupiah = parseInt(split[0]).toString().substr(0, sisa),
                    ribuan = parseInt(split[0]).toString().substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            // <-- Fungsi Get Validasi -->
            cekValidate() {
            	// return
	            var tanggalValid = $("#tgl_kasbon")[0].checkValidity();
	            (tanggalValid) ? $("#cekTanggalValid").hide() : $("#cekTanggalValid").show();
                var nominalpotongan = (this.nominal_kasbon === '') ? 0 : parseInt(this.nominal_kasbon);
                var date_kasbon = this.date_kasbon;
                var keteranganpotonganx = this.keterangan_kasbon;
                var selectedkaryawan = this.selectedkaryawan_kasbon;
                var selectedakunkasbon = this.selectedkasbon.value !== undefined ? this.selectedkasbon.value : "";
                if (nominalpotongan>0 && date_kasbon !== '' && keteranganpotonganx !=='' && selectedkaryawan !=='' && selectedakunkasbon && tanggalValid) {
                    // $('#BtnCreateKasbon').prop('disabled', false);
                } else {
                    // $('#BtnCreateKasbon').prop('disabled', true);
                }
            },

            // <-- Fungsi Get Karyawan -->

            myChangeEventkaryawan(val) {
                this.myValue = val;
            },

            async getKaryawankasbon() {
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                this.optionkaryawan_kasbon=[];
                try {
                    if (!this.listKaryawanMeta.length) {
                        const res = await this.$store.dispatch("metaModule/fetchKaryawanAll");
                        if (res.success) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                        } else {
                            this.$toast.error(res.err);
                        }
                    }
                    this.optionkaryawan_kasbon.push({id: "", text: "Pilih Karyawan"})
                    this.listKaryawanMeta.map(item => {
                        this.optionkaryawan_kasbon.push({
                            id: item.idkaryawan,
                            text: item.nama
                        })
                    })
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            // <-- Fungsi Get Data Akun -->

            async getdatakaunkasbon() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/list_akun_keuangan',this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                            var dataakun = response.data.data;
                            this.selectedakunkasbon.push({id: "", text: "Pilih Akun Kas"});
                            for (var i = 0; i < dataakun.length; i++) {
                                this.selectedakunkasbon.push({id: dataakun[i].idakun, text: dataakun[i].nama_akun, idkategori: dataakun[i].idkategori})
                            }

                        }
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            async getWorkshop() {
              $('#loadingPage').show();
              $('#loadingPage').addClass('overlayLoading');
              this.OptionWorkshop = [];
              try {
                var idowner = localStorage.getItem('idowner');
                const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_meta?idowner=' + idowner, this.requestHeaders)
                if (res.status === 200) {
                  $('#loadingPage').hide();
                  $('#loadingPage').removeClass('overlayLoading');
                  var rawworkshop = res.data.data;
                  this.OptionWorkshop.push({id: "", text: "Pilih Workshop"})
                  for (var i = 0; i < rawworkshop.length; i++) {
                    this.OptionWorkshop.push({
                      id: rawworkshop[i].idworkshop,
                      text: rawworkshop[i].nama
                    })
                  }
                }
              } catch (e) {
                this.$catch_error_response(e)
                $('#loadingPage').hide();
                $('#loadingPage').removeClass('overlayLoading');
              }
            },

            async getOutlet() {
              $('#loadingPage').show();
              $('#loadingPage').addClass('overlayLoading');
              this.OptionOutlet = [];
              try {
                var idowner = localStorage.getItem('idowner');
                const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_outlet_meta?limit=50&idowner=' + idowner, this.requestHeaders)
                if (res.status === 200) {
                  $('#loadingPage').hide();
                  $('#loadingPage').removeClass('overlayLoading');
                  var rawoutlet = res.data.data;
                  this.OptionOutlet.push({id: "", text: "Pilih Outlet"})
                  for (var i = 0; i < rawoutlet.length; i++) {
                    this.OptionOutlet.push({id: rawoutlet[i].idoutlet, text: rawoutlet[i].nama})
                  }
                }
              } catch (e) {
                this.$catch_error_response(e)
                $('#loadingPage').hide();
                $('#loadingPage').removeClass('overlayLoading');
              }
            },

            // <-- Fungsi Post Kasbon -->

	        errorValidation() {
		        this.$v.selectedkaryawan_kasbon.$touch()
		        this.$v.nominal_kasbon.$touch()
		        this.$v.date_kasbon.$touch()
		        this.$v.selectedkasbon.$touch()
		        this.$v.keterangan_kasbon.$touch()
            if(this.type_beban_kasbon === 'outlet'){
              this.$v.idoutlet.$touch()
            }else if(this.type_beban_kasbon === 'workshop') {
              this.$v.idworkshop.$touch()
            }
            	return this.$v.selectedkaryawan_kasbon.$invalid ||
		            this.$v.nominal_kasbon.$invalid ||
		            this.$v.date_kasbon.$invalid ||
		            this.$v.selectedkasbon.$invalid ||
		            this.$v.keterangan_kasbon.$invalid ||
                this.$v.idoutlet.$invalid ||
                this.$v.idworkshop.$invalid
	        },
            async createkasbon(){
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                this.isClicked = true;
                // $('#BtnCreateKasbon').prop('disabled', true);
                $('#textBtnCreateKasbon').hide();
                var coba1 = this.date_kasbon;
                var dateparse = coba1.replace('T', ' ');
                var plussecond = dateparse + ':00';
                try {
                    const kasbon = new FormData;
                    kasbon.append('idkaryawan', this.selectedkaryawan_kasbon)
                    kasbon.append('nominal',  this.nominal_kasbon)
                    kasbon.append('waktu_kasbon', plussecond)
                    kasbon.append('keterangan', this.keterangan_kasbon);
                    kasbon.append('idakun', this.selectedkasbon.value !== undefined ? this.selectedkasbon.value : "")
                    kasbon.append('type_beban_kasbon', this.type_beban_kasbon)
                    kasbon.append('id_beban_kasbon', (
                        this.type_beban_kasbon==='outlet' ?
                            this.idoutlet : this.type_beban_kasbon==='workshop' ? this.idworkshop: ''))
                    const response = await this.$axios.post(this.$baseurl + '/masterData/penggajian/tambah_kasbon_karyawan',kasbon, this.requestHeaders);
                    if (response.data.status === true) {
                        this.selectedkaryawan='';
                        this.nominal_potonganx='';
                        plussecond ='';
                        this.keterangan_potonganx='';
                        this.$toast.success(response.data.msg)
                        this.isClicked = false;
                        // $('#BtnCreateKasbon').prop('disabled', false);
                        $('#textBtnCreateKasbon').show();
	                    this.$emit("detailListKasbon", this.selectedkaryawan_kasbon)
                    }else{
                    	this.$toast.error(response.data.msg)
                        this.isClicked = false;
                        // $('#BtnCreateKasbon').prop('disabled', false);
                        $('#textBtnCreateKasbon').show();
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                // $('#BtnCreateKasbon').prop('disabled', false);
	                $('#textBtnCreateKasbon').show();
                }
            },
        }
    }
</script>

<style>

</style>